var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissingPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 971,
    height: 732,
    viewBox: "0 0 971 732",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.51 731.29C606.254 731.29 769.8 567.744 769.8 366C769.8 164.256 606.254 0.709961 404.51 0.709961C202.766 0.709961 39.2197 164.256 39.2197 366C39.2197 567.744 202.766 731.29 404.51 731.29Z",
    fill: "url(#paint0_linear_975_2352)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M631.867 222.539L612.552 225.288L616.365 252.078L635.68 249.329L631.867 222.539Z",
    fill: "#C16E6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M634.226 238.57L614.91 241.319L616.442 252.081L635.757 249.332L634.226 238.57Z",
    fill: "#F4AFAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M617.558 236.612L614.297 237.118L615.965 247.859L619.226 247.353L617.558 236.612Z",
    fill: "#F5C6BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M615.071 220.611L611.811 221.118L614.296 237.116L617.557 236.609L615.071 220.611Z",
    fill: "#DD9075"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M612.5 225.47L631.7 222.02L632.76 228.81C632.76 228.81 618.63 233.73 612.5 225.47Z",
    fill: "#63496A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M612.5 225.47C613.512 226.822 614.827 227.918 616.34 228.67L615.76 224.96L612.5 225.47Z",
    fill: "#695974"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M833 657.75L659.53 614.13L644.76 693.41L840.65 695.39L833 657.75Z",
    fill: "#C16E6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M847.49 646.64L966 684.91C973 687.17 971.28 697.49 963.94 697.37L834.59 695.37L830 661.24C829.699 658.985 829.974 656.691 830.8 654.571C831.625 652.451 832.974 650.575 834.72 649.118C836.466 647.66 838.553 646.668 840.786 646.235C843.019 645.802 845.325 645.941 847.49 646.64V646.64Z",
    fill: "#C16E6A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M966 684.91L847.51 646.64C845.346 645.943 843.041 645.805 840.809 646.24C838.577 646.674 836.492 647.666 834.747 649.123C833.002 650.581 831.655 652.456 830.83 654.575C830.005 656.693 829.73 658.986 830.03 661.24L830.35 663.65C830.84 663.65 831.35 663.58 831.81 663.58C840.616 663.582 849.097 666.91 855.555 672.897C862.013 678.884 865.972 687.089 866.64 695.87L963.94 697.37C971.26 697.49 973 687.17 966 684.91Z",
    fill: "#F8CDA0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M818.8 654.18L814.55 695.01L788.76 694.86L811.36 652.48L818.8 654.18Z",
    fill: "#63496A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M651.47 693.39C645.976 693.332 640.726 691.115 636.854 687.217C632.983 683.319 630.801 678.054 630.78 672.56L629.87 424.26L623.26 423.56L624.17 672.56C624.193 678.053 626.376 683.317 630.247 687.214C634.118 691.111 639.367 693.33 644.86 693.39L696.91 693.94V693.87L651.47 693.39Z",
    fill: "#FCBF86"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M805 635.74L710.7 621.74L745.7 438.36C751.665 407.071 745.286 374.689 727.9 348V348L623.33 423.57L624.25 672.57C624.27 678.045 626.437 683.294 630.285 687.189C634.133 691.083 639.356 693.314 644.83 693.4V693.4L696.97 693.93L803.23 695L817.7 657.61C818.575 655.346 818.93 652.914 818.739 650.494C818.548 648.074 817.816 645.727 816.597 643.628C815.378 641.529 813.703 639.73 811.696 638.365C809.689 637 807.4 636.103 805 635.74V635.74Z",
    fill: "#F3A978"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M727.83 348L579.72 367L580.41 284.8C580.503 274.36 584.316 264.295 591.164 256.414C598.012 248.533 607.445 243.351 617.77 241.8L637.16 238.89C646.17 237.541 655.376 239.031 663.501 243.153C671.626 247.274 678.266 253.823 682.5 261.89L727.83 348Z",
    fill: "#F4AFAD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M588 290.51C588.19 268.94 596.4 244.98 617.73 241.78C607.405 243.331 597.972 248.512 591.124 256.394C584.276 264.275 580.463 274.34 580.37 284.78L579.68 366.98L587.36 365.98L588 290.51Z",
    fill: "#F5C6BA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M745.36 438.63L738.17 475.45L606.82 486.05L579.72 367L727.83 348L728.17 348.54C745.275 375.241 751.431 407.507 745.36 438.63V438.63Z",
    fill: "#F3A978"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M506.65 660.73L509.24 641.25L458.66 642.72C473.579 651.276 489.786 657.359 506.65 660.73V660.73Z",
    fill: "#63496A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M488.24 410C473.685 416.659 461.575 427.7 453.604 441.58C445.632 455.459 442.198 471.483 443.78 487.41L446.37 513.41L462 678.08L504.78 674.67L526.47 511.48L532.27 389.86L488.24 410Z",
    fill: "#C16E6A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M657.25 507.4L579.72 367L532.29 389.87L486.86 410.67C472.621 417.187 460.716 427.901 452.739 441.376C444.762 454.851 441.095 470.442 442.23 486.06L452.83 631.55C453.123 635.596 454.935 639.381 457.902 642.147C460.87 644.912 464.774 646.453 468.83 646.46H500.71C507.577 646.475 514.176 643.797 519.091 639.002C524.006 634.206 526.846 627.675 527 620.81L529.53 511.39L657.25 507.4Z",
    fill: "#F3A978"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M460.46 637.27L449.86 491.78C448.723 476.161 452.389 460.567 460.366 447.09C468.343 433.613 480.25 422.897 494.49 416.38L587.4 366L579.72 367L532.29 389.87L486.86 410.67C472.622 417.188 460.717 427.902 452.74 441.377C444.764 454.852 441.096 470.442 442.23 486.06L452.83 631.55C453.049 634.664 454.172 637.647 456.059 640.133C457.947 642.62 460.519 644.502 463.46 645.55C461.705 643.125 460.666 640.256 460.46 637.27V637.27Z",
    fill: "#FCBF86"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M679.66 343.68L641.76 350.1C641.76 350.1 670.37 354.4 681.1 350.99L679.66 343.68ZM754.91 389.59C754.91 389.77 754.86 389.95 754.82 390.13L754.93 389.59H754.91Z",
    fill: "#63496A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M623.26 508.46L675.77 505.79C696.171 504.751 715.55 496.542 730.49 482.61L738.17 475.45L732.4 506C728.708 508.438 724.66 510.286 720.4 511.48C686.8 521.56 623.26 508.46 623.26 508.46Z",
    fill: "#E08B52"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M608.63 212.75C602.93 214.05 599.95 197.36 601.15 193.29C603.49 177.41 641.85 178.14 635.35 196.69C637.92 197.35 639.67 208.28 636.56 211.15C626.66 220.32 618.44 213.29 608.63 212.75Z",
    fill: "#303363"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M605 197.1C606.64 186 625.88 183.03 635.09 188.59C629.53 178.41 603.09 180.19 601.19 193.29C600.06 197.11 602.63 212.06 607.66 212.79C605.21 207.9 604.18 199.78 605 197.1Z",
    fill: "#695974"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M634.9 203.64C634.9 195.477 628.283 188.86 620.12 188.86C611.957 188.86 605.34 195.477 605.34 203.64V212.84C605.34 221.003 611.957 227.62 620.12 227.62C628.283 227.62 634.9 221.003 634.9 212.84V203.64Z",
    fill: "#C16E6A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M634.911 212.55C635.281 208.63 639.341 199.55 633.911 198.55C633.091 188.55 615.161 184.68 608.651 189.78C601.211 195.61 605.121 211.34 605.121 211.34C606.575 207.364 607.277 203.153 607.19 198.92C615.19 199.45 624.591 199.35 632.371 197.68C633.151 202.18 633.471 209.13 634.911 212.55Z",
    fill: "#303363"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M215.6 500.2H1.58984V718.99H215.6V500.2Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0698 524.28H21.7798V540.53H82.0698V524.28Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.53 679.56H137.24V695.81H197.53V679.56Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M429.61 500.2H215.6V718.99H429.61V500.2Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M296.08 524.28H235.79V540.53H296.08V524.28Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M275.4 281.41H61.3901V500.2H275.4V281.41Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M275.4 500.21H363.57V281.42H275.4V500.21Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.87 305.49H81.5801V321.74H141.87V305.49Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M257.33 460.77H197.04V477.02H257.33V460.77Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M416.85 230.91H328.68L275.39 281.41H363.57L416.85 230.91Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02979 230.91H96.2098L149.49 281.41H61.3198L8.02979 230.91Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M514.01 304.21H338.5V483.64H514.01V304.21Z",
    fill: "#549999"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M514.01 483.63H586.32V304.2H514.01V483.63Z",
    fill: "#388888"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M404.52 323.95H355.07V337.28H404.52V323.95Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M499.2 451.3H449.75V464.63H499.2V451.3Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M630.02 380.75H557.71L514.01 304.21H586.32L630.02 380.75Z",
    fill: "#549999"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 380.75H338.5L338.45 304.21L294.75 380.75Z",
    fill: "#388888"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M325.1 679.56H264.81V695.81H325.1V679.56Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M573.64 540.53H399.08V718.99H573.64V540.53Z",
    fill: "#549999"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M464.73 560.17H415.55V573.43H464.73V560.17Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M558.9 686.83H509.72V700.09H558.9V686.83Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M573.63 719H645.55V540.54H573.63V719Z",
    fill: "#388888"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M661.67 252L612.1 265.23L644.41 357.68L560.18 428.51L570.39 442.95L669.49 381.26C674.088 378.395 677.706 374.2 679.865 369.232C682.025 364.263 682.623 358.756 681.58 353.44L661.67 252Z",
    fill: "#C16E6A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M560.47 428.38L526.92 431.09C526.179 431.151 525.475 431.438 524.904 431.914C524.332 432.39 523.922 433.03 523.728 433.748C523.535 434.465 523.567 435.225 523.822 435.924C524.076 436.622 524.54 437.225 525.15 437.65L536.52 445.55C537.106 445.952 537.56 446.52 537.823 447.18C538.087 447.841 538.148 448.565 538 449.26L529 492C528.826 492.821 528.942 493.676 529.33 494.42C529.718 495.164 530.353 495.749 531.126 496.076C531.898 496.402 532.76 496.449 533.564 496.209C534.368 495.969 535.063 495.457 535.53 494.76L570.53 442.7C570.954 442.068 571.168 441.317 571.141 440.556C571.114 439.795 570.848 439.061 570.38 438.46L563.58 429.76C563.213 429.294 562.738 428.925 562.196 428.684C561.654 428.444 561.061 428.339 560.47 428.38V428.38Z",
    fill: "#C16E6A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M537.32 489.23L546.32 446.48C546.467 445.786 546.406 445.063 546.144 444.404C545.883 443.744 545.432 443.176 544.85 442.77L533.48 434.88C532.818 434.427 532.33 433.763 532.094 432.997C531.858 432.231 531.888 431.407 532.18 430.66L526.92 431.09C526.179 431.151 525.475 431.438 524.904 431.914C524.332 432.39 523.922 433.03 523.728 433.748C523.535 434.465 523.567 435.225 523.822 435.924C524.076 436.622 524.54 437.225 525.15 437.65L536.52 445.55C537.106 445.952 537.56 446.52 537.823 447.18C538.087 447.841 538.148 448.565 538 449.26L529 492C528.826 492.821 528.942 493.676 529.33 494.42C529.718 495.164 530.353 495.749 531.126 496.076C531.898 496.402 532.76 496.449 533.564 496.209C534.368 495.969 535.063 495.457 535.53 494.76L537.64 491.62C537.25 490.888 537.136 490.039 537.32 489.23Z",
    fill: "#DD9075"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M684.49 342.86L666.3 250.2L606.82 266.07L636.5 350.99L684.49 342.86Z",
    fill: "#F4AFAD"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M613.43 266.07H606.82L636.5 350.99L642.45 349.11L613.43 266.07Z",
    fill: "#F5C6BA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M615.11 289.8C616.11 292.31 617.11 294.8 618.04 297.36L620.86 304.96C622.73 310.03 624.5 315.13 626.33 320.21C628.16 325.29 629.85 330.42 631.55 335.55L634.08 343.25C634.88 345.83 635.72 348.4 636.5 350.99C635.5 348.48 634.5 345.99 633.57 343.43L630.75 335.83C628.89 330.76 627.11 325.66 625.29 320.58C623.47 315.5 621.76 310.36 620.06 305.24L617.53 297.54C616.73 295 615.89 292.39 615.11 289.8ZM671.23 275.27C671.9 278.06 672.51 280.87 673.15 283.67L674.96 292.09C676.15 297.7 677.25 303.33 678.4 308.96C679.55 314.59 680.57 320.23 681.59 325.88L683.1 334.36C683.56 337.19 684.1 340.02 684.49 342.86C683.82 340.07 683.21 337.26 682.57 334.46L680.76 326.04C679.57 320.43 678.47 314.8 677.32 309.17C676.17 303.54 675.15 297.9 674.13 292.25L672.62 283.77C672.16 280.93 671.66 278.11 671.23 275.27Z",
    fill: "#916881"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_975_2352",
    x1: 404.51,
    y1: 0.709961,
    x2: 404.51,
    y2: 731.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CDA0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CDA0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingPackage);
export default __webpack_public_path__ + "static/media/MissingPackage.2db1ee59a25f28bb7528734a6f982d2f.svg";
export { ForwardRef as ReactComponent };